import React from "react";

import "./Range.scss";

export type RangeProps = {
  label: React.ReactNode;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  hasCommonValue?: boolean;
  testId?: string;
};

export const Range = ({
  label,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 10,
  hasCommonValue = true,
  testId,
}: RangeProps) => {
  const progress = hasCommonValue
    ? ((value - min) / (max - min || 1)) * 100
    : 0;

  return (
    <div className="range-wrapper">
      <div
        className="range-track"
        style={{ ["--range-progress" as string]: `${progress}%` }}
      >
        <div className="range-track__fill" />
        <span className="range-track__label">{label}</span>
        <input
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={(event) => onChange(+event.target.value)}
          className="range-input"
          aria-label={typeof label === "string" ? label : undefined}
          data-testid={testId}
        />
      </div>
      <div className="range-value">
        {hasCommonValue ? `${value}%` : "Mixed"}
      </div>
    </div>
  );
};
